// @ts-nocheck
/**
 * Dynamic Yield Add-to-Cart
 *
 * Handles add-to-cart actions from DY recommendation widgets.
 * Targets elements with [data-dy-add-to-cart][data-variant-id].
 *
 * Cart behaviour is determined by the theme configuration:
 *  - Drawer mode: cart-drawer-component exists in the DOM
 *    (rendered only when settings.cart_type == 'drawer').
 *    The drawer auto-opens via its native CartAddEvent listener
 *    when the auto-open attribute is present.
 *  - Page mode: no drawer in DOM → redirect to /cart.
 */
(function () {
  'use strict';

  var SELECTOR = '[dy-add-to-cart][data-variant-id]';
  var FEEDBACK_DELAY_MS = 2000;

  /**
   * Collect section IDs from all cart-items-component instances on the page
   * so the /cart/add.js response includes pre-rendered HTML for each.
   * @returns {string}
   */
  function getCartSectionIds() {
    var ids = [];
    var components = document.querySelectorAll('cart-items-component[data-section-id]');
    for (var i = 0; i < components.length; i++) {
      var id = components[i].getAttribute('data-section-id');
      if (id) ids.push(id);
    }
    return ids.join(',');
  }

  /**
   * @returns {boolean} True when the theme is configured for drawer cart.
   */
  function isDrawerMode() {
    return !!document.querySelector('cart-drawer-component');
  }

  /**
   * Dispatch cart:update so native components (cart-items, cart-drawer,
   * progress bar, icon bubble, etc.) react to the new item.
   * @param {object|null} response  - JSON from /cart/add.js
   * @param {object|null} sections  - Section HTML map (may be embedded in response)
   */
  function dispatchCartEvents(response, sections) {
    var sectionData = sections || (response && response.sections) || null;
    var itemCount = response && typeof response.quantity === 'number' ? response.quantity : 1;

    document.dispatchEvent(new CustomEvent('cart:added', {
      bubbles: true,
      detail: {
        resource: response,
        data: {
          source: 'dy-add-to-cart',
          addedItems: [
            {
              sku: "",
              price: "",
              quantity: itemCount,
              variant_id: ""
            }
          ],
        }
      }
    }));

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: response,
        data: {
          source: 'dy-add-to-cart',
          itemCount: itemCount,
          sections: sectionData
        }
      }
    }));

    document.dispatchEvent(new CustomEvent('cart:synced', {
      bubbles: true,
      detail: { source: 'dy-add-to-cart' }
    }));
  }

  /**
   * Open the cart drawer programmatically (fallback if auto-open isn't set).
   */
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    }
  }

  /**
   * Add a variant to the cart and handle post-add behaviour based on theme config.
   * @param {string} variantId
   * @param {HTMLButtonElement} button
   */
  function dyAddToCart(variantId, button) {
    var originalText = button.textContent || '';
    button.disabled = true;
    button.textContent = 'Adding...';
    button.setAttribute('aria-busy', 'true');

    var sections = getCartSectionIds();
    var payload = { id: parseInt(variantId, 10), quantity: 1 };
    if (sections) payload.sections = sections;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          button.textContent = data.description || data.message || 'Error';
          button.disabled = false;
          button.removeAttribute('aria-busy');
          return;
        }

        button.textContent = 'Added';
        button.removeAttribute('aria-busy');

        dispatchCartEvents(data, data.sections || null);

        if (isDrawerMode()) {
          var drawer = document.querySelector('cart-drawer-component');
          var hasAutoOpen = drawer && drawer.hasAttribute('auto-open');
          if (!hasAutoOpen) {
            openCartDrawer();
          }
        } else {
          var cartUrl = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url)
            ? Theme.routes.cart_url
            : '/cart';
          window.location.href = cartUrl;
          return;
        }

        setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, FEEDBACK_DELAY_MS);
      })
      .catch(function () {
        button.textContent = 'Error';
        button.removeAttribute('aria-busy');
        setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, FEEDBACK_DELAY_MS);
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !(e.target instanceof Element)) return;

    var btn = e.target.closest(SELECTOR);
    if (!btn || !(btn instanceof HTMLElement)) return;

    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    dyAddToCart(variantId, btn);
  });
})();
